module.exports = __webpack_public_path__ + "media/packs/images/markers/current-location-0f4eebc28d56c070cffc18459ba56481.svg";